import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforoutstationinpune() {



  const cardData =
  {
    keyword: 'Urbania Hire for Outstation in Pune',
    heading: 'Amruta Travels: Urbania Hire for Outstation in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Urbania Hire for Outstation in Pune, providing a perfect mix of luxury, space, and comfort for long-distance travel. Our premium Force Urbania vans are ideal for family vacations, corporate tours, wedding trips, and pilgrimage journeys, ensuring a smooth and enjoyable ride to destinations like Goa, Shirdi, Mahabaleshwar, Lonavala, and Nashik. Each Urbania is equipped with plush push-back seats, strong air conditioning, ample luggage capacity, and elegant interiors, making your journey as comfortable as it is stylish. Driven by skilled and courteous chauffeurs, Amruta Travels’ Outstation Urbania Rental in Pune guarantees punctuality, safety, and a world-class travel experience for every group.',

    top: 'Top Places to Visit in Pune Outstation with Amruta Travels',

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Lonavala and Khandala are twin hill stations just 65 km from Pune, famous for their misty hills, waterfalls, and lush valleys. Popular spots like Tiger’s Leap, Bhushi Dam, and Rajmachi Fort offer stunning natural beauty. During monsoon, the region turns into a paradise with greenery all around. These hill towns are Pune’s favorite weekend getaway for nature and peace lovers."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Mahabaleshwar and Panchgani are scenic hill stations located about 120 km from Pune. Known for strawberry farms, Venna Lake, and Table Land, they offer cool weather and charming views of the Western Ghats. Tourists enjoy boating, trekking, and exploring viewpoints like Arthur’s Seat and Wilson Point. Together, they form Pune’s most refreshing high-altitude retreat."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a beautifully planned city built amidst the Sahyadri hills, about 60 km from Pune. Designed in Italian style, it offers lakeside promenades, adventure sports, and serene resorts. Boating, cycling, and photography are popular here. Lavasa is Pune’s modern outstation escape, blending luxury with natural charm."
  },
  {
    "title": "Matheran",
    "description": "Matheran, Asia’s only automobile-free hill station, lies around 120 km from Pune. The toy train ride, lush forests, and panoramic viewpoints make it a delightful trip. Charlotte Lake and Echo Point are major attractions. Matheran’s unpolluted air and vintage charm make it Pune’s most peaceful outstation retreat."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, a serene coastal town about 140 km from Pune, is known for its beaches, forts, and water sports. Mandwa Beach, Kolaba Fort, and Nagaon Beach attract both families and adventure seekers. The beachside resorts and ferry rides from Mumbai add to the experience. Alibaug is Pune’s perfect seaside weekend destination."
  },
  {
    "title": "Imagicaa Theme Park (Khopoli)",
    "description": "Located 90 km from Pune, Imagicaa is one of India’s premier amusement parks offering thrilling rides, live entertainment, and a water park. From roller coasters to themed attractions, it’s a family favorite for fun and excitement. The park also has luxurious stays nearby. Imagicaa is Pune’s most thrilling outstation adventure for all age groups."
  },
  {
    "title": "Bhimashankar Temple & Wildlife Sanctuary",
    "description": "Bhimashankar, about 110 km from Pune, is one of the twelve Jyotirlingas of Lord Shiva. Set amidst dense forests, it’s both a spiritual and natural retreat. The sanctuary is home to the rare Giant Squirrel and many bird species. Bhimashankar offers Pune travelers a divine blend of faith, trekking, and wildlife."
  },
  {
    "title": "Nashik",
    "description": "Nashik, located 210 km from Pune, is a city of temples, vineyards, and riverside ghats. Known for Trimbakeshwar Temple and Sula Vineyards, it attracts both pilgrims and wine enthusiasts. The annual Kumbh Mela is its major highlight. Nashik is Pune’s ideal spiritual and scenic getaway."
  },
  {
    "title": "Kolad (River Rafting)",
    "description": "Kolad, around 115 km from Pune, is an adventure hotspot famous for its white-water rafting on the Kundalika River. Surrounded by hills and waterfalls, it’s perfect for camping, kayaking, and ziplining. The gushing rapids offer an adrenaline-filled experience. Kolad is Pune’s ultimate destination for thrill-seekers and nature explorers."
  },
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "Kaas Plateau, a UNESCO World Heritage Site about 140 km from Pune, is a mesmerizing floral paradise. During monsoon, the entire plateau blooms with colorful wildflowers, creating breathtaking views. Nature lovers and photographers flock here every year. Kaas Plateau is Pune’s magical outstation haven of biodiversity and color."
  }
],



       "services": [
    {
      "name": "Urbania Hire for Outstation in Pune",
      "description": "Urbania Hire for Outstation in Pune offers a premium travel solution for long-distance group journeys, ensuring maximum comfort and reliability throughout the trip. Each Force Urbania comes equipped with plush seating, high-performance air conditioning, and advanced suspension for smooth rides even on winding mountain roads. Whether you’re heading to hill stations like Mahabaleshwar or beaches in Goa, this service guarantees a luxurious and safe journey. Drivers are professionally trained and experienced in long-route navigation, prioritizing passenger comfort and punctuality. With flexible rental packages, on-time pickups, and 24x7 support, this Urbania hire ensures a delightful outstation experience tailored for family tours, business travel, and leisure vacations."
    },
    {
      "name": "Outstation Urbania Rental Pune",
      "description": "Outstation Urbania Rental Pune is perfect for travelers seeking dependable and comfortable group transportation across Maharashtra and beyond. Each vehicle features spacious interiors, powerful AC, reclining seats, and ample legroom for long trips. Designed for ultimate relaxation, the ride remains smooth and quiet even on highways and ghats. The service caters to family tours, pilgrimages, and corporate retreats, offering customized rental durations for single or multi-day journeys. Professional chauffeurs ensure safety and efficiency throughout the route. Customers benefit from transparent pricing, online booking, and flexible itineraries, making Outstation Urbania Rental Pune the ideal choice for scenic and worry-free travel."
    },
    {
      "name": "Urbania for Long Trip Pune",
      "description": "Urbania for Long Trip Pune specializes in extended travel experiences with vehicles designed for endurance and comfort. These modern Force Urbanias are built with ergonomic seats, reading lights, and entertainment systems to keep passengers relaxed during long hours on the road. Whether it’s a multi-city tour, family vacation, or weekend adventure, this service ensures unmatched convenience and safety. Drivers are trained for intercity routes and manage long drives with professionalism and patience. With plenty of luggage space, on-road assistance, and flexible pickup options, travelers can embark on memorable journeys without fatigue. It’s the ultimate choice for those planning long road trips from Pune."
    },
    {
      "name": "Urbania for Shirdi Trip Pune",
      "description": "Urbania for Shirdi Trip Pune provides a smooth, spiritual, and comfortable ride for pilgrims and families visiting Sai Baba’s holy temple. The vehicles are air-conditioned, clean, and equipped with push-back seats to ensure a pleasant journey over long distances. Experienced chauffeurs familiar with the Pune–Shirdi route manage safe, timely travel while allowing convenient breaks for meals or sightseeing. The service is popular among families and devotees looking for safe, organized transport for temple visits and return trips. With flexible scheduling, reliable service, and affordable pricing, this Urbania ensures your spiritual journey begins and ends in complete peace and comfort."
    },
    {
      "name": "Urbania for Mahabaleshwar Pune",
      "description": "Urbania for Mahabaleshwar Pune is the perfect choice for travelers seeking a comfortable ride to the scenic hill station. The vehicles are fitted with AC, wide windows for panoramic views, and cushioned seating that ensures relaxation even through curvy ghat sections. Families, friends, and corporate groups love this service for its smooth navigation and well-maintained vehicles. Drivers are skilled in handling mountain roads and offer safe, punctual service. The journey becomes a part of the vacation experience with flexible stops at Mapro Garden, Venna Lake, and other attractions. Combining luxury and reliability, this service makes every Mahabaleshwar trip memorable."
    },
    {
      "name": "Urbania for Goa Pune",
      "description": "Urbania for Goa Pune delivers an unforgettable travel experience from Pune to the coastal paradise of Goa. The vehicles are designed for long-distance comfort, offering air conditioning, spacious interiors, reclining seats, and entertainment systems. Passengers enjoy smooth travel across highways with skilled drivers who handle overnight and long-route journeys efficiently. The service is ideal for beach holidays, corporate retreats, or family vacations. With flexible departure timings, convenient booking options, and professional support, this Urbania rental ensures you reach Goa refreshed and ready to enjoy your trip. It’s the most stylish and relaxing way to travel between Pune and Goa."
    },
    {
      "name": "Force Urbania Outstation Pune",
      "description": "Force Urbania Outstation Pune is a dependable travel service crafted for those seeking luxurious, safe, and efficient outstation transport. The vehicles feature robust build quality, advanced air conditioning, and ergonomic design for maximum passenger comfort. It’s ideal for long journeys, business trips, or weekend getaways. Every vehicle is checked before departure to ensure mechanical safety and cleanliness. Professional chauffeurs with years of intercity driving experience make the ride smooth and stress-free. The service includes flexible packages for one-way, round-trip, or multi-destination travel. With customer satisfaction as a priority, this is Pune’s top choice for reliable outstation rides."
    },
    {
      "name": "Urbania Hire in Hinjewadi",
      "description": "Urbania Hire in Hinjewadi caters to the corporate community and tech professionals who frequently travel for meetings, events, and outstation conferences. The vehicles are maintained to luxury standards and equipped with Wi-Fi, air conditioning, and modern interiors. Drivers are trained to ensure punctual pickups and efficient route navigation. Whether it’s a day trip or a weekend retreat, this service offers flexible scheduling and seamless travel management. With round-the-clock support and easy online booking, Urbania Hire in Hinjewadi is the perfect solution for both business and leisure travel from Pune’s IT hub."
    },
    {
      "name": "Urbania Hire in Baner",
      "description": "Urbania Hire in Baner provides reliable and luxurious mini-bus rentals for families, corporates, and travelers in Pune’s bustling neighborhood. Each Urbania comes equipped with advanced safety systems, push-back seats, and AC options suitable for city and outstation routes. The drivers are courteous and knowledgeable about major routes across Maharashtra. Whether planning a wedding convoy, family trip, or business travel, this service ensures smooth coordination and timely pickups. Affordable packages and clean vehicles make it a favorite choice for Baner residents seeking comfortable outstation transport."
    },
    {
      "name": "Urbania Hire in Hadapsar",
      "description": "Urbania Hire in Hadapsar provides versatile outstation travel options for residents and businesses in eastern Pune. The service offers both AC and luxury variants, ensuring comfort on long highway routes. Vehicles are sanitized and serviced before every trip, promising safety and cleanliness. Drivers are punctual, courteous, and well-versed in intercity navigation. Whether for corporate tours, pilgrimages, or family vacations, this Urbania hire ensures a comfortable and dependable journey. Customers can select flexible rental durations with transparent pricing, making it the preferred outstation transport service in Hadapsar."
    },
    {
      "name": "AC Urbania Outstation Pune",
      "description": "AC Urbania Outstation Pune guarantees a refreshing and cool travel experience for long road trips. The vehicles are equipped with powerful air conditioning, reclining seats, and smooth suspension for a fatigue-free journey. Ideal for family holidays, corporate outings, and tours to hill stations, the service offers luxurious comfort at every stage. Regular vehicle checks and professional drivers ensure top safety standards. Passengers can relax, enjoy scenic drives, and reach their destinations comfortably. With flexible pickup options and responsive customer service, AC Urbania Outstation Pune makes long journeys a pleasant experience."
    },
    {
      "name": "Non AC Urbania Outstation Pune",
      "description": "Non AC Urbania Outstation Pune provides economical group travel for short and mid-range distances while maintaining reliability and comfort. The vehicles feature clean, spacious interiors and comfortable seating, ensuring passengers enjoy smooth rides. Perfect for school trips, pilgrimages, and budget tours, this service emphasizes affordability without compromising safety. Drivers are experienced and polite, ensuring timely arrivals and safe driving through long routes. Transparent rates and easy booking make it an excellent option for cost-conscious travelers planning outstation journeys from Pune."
    },
    {
      "name": "Luxury Urbania Outstation Pune",
      "description": "Luxury Urbania Outstation Pune provides elite travelers with a sophisticated travel experience. Each vehicle boasts leather-finished interiors, LED lighting, climate control, and entertainment systems. It’s ideal for executives, VIPs, and families who appreciate comfort and class. The service ensures on-time pickups, personalized routes, and professional chauffeurs who prioritize privacy and elegance. From Pune to destinations like Lonavala, Goa, or Shirdi, every ride is an indulgence in style. With round-the-clock availability and meticulous vehicle upkeep, Luxury Urbania Outstation Pune defines premium road travel."
    },
    {
      "name": "Affordable Urbania Pune",
      "description": "Affordable Urbania Pune delivers quality travel services at budget-friendly prices. The vehicles are clean, comfortable, and perfect for families, school groups, and small organizations. Despite its economical pricing, the service ensures top-notch safety, hygiene, and punctuality. Passengers can choose between AC and Non-AC variants based on their needs. Transparent fare structures, flexible schedules, and courteous drivers make this service a favorite among regular travelers. Whether for short city transfers or long outstation drives, Affordable Urbania Pune combines savings with satisfaction."
    },
    {
      "name": "Force Urbania Booking Pune",
      "description": "Force Urbania Booking Pune simplifies the process of reserving premium outstation vehicles with instant confirmation and multiple payment options. The platform allows customers to select preferred seating, vehicle type, and travel duration effortlessly. Each booking includes experienced drivers, well-maintained vehicles, and real-time support for modifications. Designed for modern travelers, it ensures flexibility, transparency, and complete convenience. With 24/7 assistance and competitive pricing, Force Urbania Booking Pune is the one-stop destination for reliable and comfortable group transport bookings."
    },
    {
      "name": "Urbania Outstation Van Pune",
      "description": "Urbania Outstation Van Pune provides group travelers with luxurious vans designed for comfort, safety, and endurance. These vehicles are ideal for families, tour groups, and corporates traveling to distant destinations. Equipped with AC, ample storage, and reclining seats, they ensure long journeys are restful. Skilled drivers handle every route professionally, making each trip seamless and enjoyable. The service also supports custom itineraries, multi-stop travel, and flexible rentals. With its combination of premium comfort and affordable pricing, Urbania Outstation Van Pune is the best companion for exploring India’s beautiful routes."
    },
    {
      "name": "Tourist Urbania Pune",
      "description": "Tourist Urbania Pune is designed specifically for sightseeing and leisure travelers. These mini buses feature panoramic windows, comfortable seating, and smooth suspension to make sightseeing enjoyable. The service covers tourist hotspots like Lonavala, Mahabaleshwar, Shirdi, and Nashik with professional drivers who double as local guides. Ideal for families and friend groups, the travel experience combines convenience with scenic exploration. With affordable pricing, flexible stops, and modern amenities, Tourist Urbania Pune ensures a memorable and photo-worthy journey for every traveler."
    },
    {
      "name": "Urbania Outstation near Me Pune",
      "description": "Urbania Outstation near Me Pune makes finding a reliable outstation vehicle simple and quick. The service connects you to the nearest available Force Urbania within minutes, offering both AC and luxury options. Perfect for spontaneous travel, last-minute plans, or planned getaways, customers enjoy convenient pickup and flexible bookings. Each vehicle is inspected for safety and cleanliness before dispatch. With courteous drivers and responsive service, this localized solution ensures comfortable travel from any area of Pune. Wherever you are, a dependable Urbania is always nearby for your next journey."
    }
  ],
  "tableData": [
    ["Urbania Hire for Outstation in Pune", "Outstation Urbania Rental Pune"],
    ["Urbania for Long Trip Pune", "Urbania for Shirdi Trip Pune"],
    ["Urbania for Mahabaleshwar Pune", "Urbania for Goa Pune"],
    ["Force Urbania Outstation Pune", "Urbania Hire in Hinjewadi"],
    ["Urbania Hire in Baner", "Urbania Hire in Hadapsar"],
    ["AC Urbania Outstation Pune", "Non AC Urbania Outstation Pune"],
    ["Luxury Urbania Outstation Pune", "Affordable Urbania Pune"],
    ["Force Urbania Booking Pune", "Urbania Outstation Van Pune"],
    ["Tourist Urbania Pune", "Urbania Outstation near Me Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania Hire for Outstation in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers reliable and comfortable Urbania hire services for outstation trips from Pune, perfect for group travel to nearby cities and tourist destinations."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans provide ample legroom and ergonomic seating to ensure a relaxing long-distance journey."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "We regularly service and sanitize our vehicles to guarantee safety, hygiene, and comfort throughout your outstation trip."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy clear pricing with no hidden charges, making your outstation travel budget-friendly and hassle-free."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your outstation travel plans."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers are knowledgeable about outstation routes, ensuring safe, timely, and smooth journeys."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, itinerary changes, and travel assistance."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Urbania hire for outstation trips easily online or via phone, with prompt vehicle delivery and dependable service."
  }
]











  }

  
const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania hire for outstation trips from Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Urbania vehicles for outstation hire from Pune, ideal for comfortable long-distance travel.',
  },
  {
    question: 'How can I book Urbania for outstation trips from Pune with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What amenities are available in the Urbania vehicles for outstation hires?',
    answer: 'Our Urbania vehicles come with comfortable seating, air conditioning, and essential safety features for a pleasant journey.',
  },
  {
    question: 'Are the drivers experienced in handling outstation routes for Urbania hires from Pune?',
    answer: 'Yes, our drivers are professional, experienced, and familiar with outstation routes to ensure a safe and timely trip.',
  },
  {
    question: 'Can Urbania vehicles be hired for one-way or round trips for outstation travel?',
    answer: 'Absolutely. We offer flexible booking options for both one-way and round trips for outstation travel.',
  },
  {
    question: 'Is the Urbania outstation hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Urbania outstation hire services to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for Urbania outstation hires?',
    answer: 'All vehicles are sanitized thoroughly before each trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for Urbania outstation hires in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Urbania outstation hire period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your Urbania rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'The Urbania hired for our outstation trip from Pune was very comfortable and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Great service for Urbania outstation hire. Amruta Travels made our journey smooth and enjoyable.',
    rating: 5,
  },
];












































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Urbania Hire for Outstation in Pune",
  "description": "Book Urbania for outstation trips from Pune with Amruta Travels Pvt. Ltd. Comfortable AC and Non-AC Force Urbania options for Shirdi, Mahabaleshwar, Goa and other long trips. Affordable and luxury Urbania rental services.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels Pvt. Ltd.",
    "url": "https://www.amrutatravelspvtltd.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": "Urbania Rental",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/urbania-hire-outstation-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Urbania Hire for Outstation in Pune | Affordable & Luxury Outstation Urbania Rental | Amruta Travels</title>
  <meta
    name="description"
    content="Book Urbania for outstation trips from Pune with Amruta Travels Pvt. Ltd. Comfortable AC and Non-AC Force Urbania options for Shirdi, Mahabaleshwar, Goa and other long trips. Affordable and luxury Urbania rental services."
  />
  <meta
    name="keywords"
    content="Urbania Hire for Outstation in Pune, Outstation Urbania Rental Pune, Urbania for Long Trip Pune, Urbania for Shirdi Trip Pune, Urbania for Mahabaleshwar Pune, Urbania for Goa Pune, Force Urbania Outstation Pune, Urbania Hire in Hinjewadi, Urbania Hire in Baner, Urbania Hire in Hadapsar, AC Urbania Outstation Pune, Non AC Urbania Outstation Pune, Luxury Urbania Outstation Pune, Affordable Urbania Pune, Force Urbania Booking Pune, Urbania Outstation Van Pune, Tourist Urbania Pune, Urbania Outstation near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniahireforoutstationinpune;